import { Injectable, inject } from '@angular/core';
import { HTTP_AP_BulkSetClientUsersNotificationSettings_Request } from '@api-new/notificationservice/HTTP_AP_BulkSetClientUsersNotificationSettings_Request';
import { HTTP_AP_ExportEmailNotificationReporting_Request } from '@api-new/notificationservice/HTTP_AP_ExportEmailNotificationReporting_Request';
import { HTTP_AP_GenerateEmailNotificationReportingDashboardPDF_Request } from '@api-new/notificationservice/HTTP_AP_GenerateEmailNotificationReportingDashboardPDF_Request';
import { HTTP_AP_GenerateEmailNotificationReportingDashboardPDF_Response } from '@api-new/notificationservice/HTTP_AP_GenerateEmailNotificationReportingDashboardPDF_Response';
import { HTTP_AP_GetAdvisorUserNotificationSettings_Request } from '@api-new/notificationservice/HTTP_AP_GetAdvisorUserNotificationSettings_Request';
import { HTTP_AP_GetAdvisorUserNotificationSettings_Response } from '@api-new/notificationservice/HTTP_AP_GetAdvisorUserNotificationSettings_Response';
import { HTTP_AP_GetClientUserNotificationSettings_Request } from '@api-new/notificationservice/HTTP_AP_GetClientUserNotificationSettings_Request';
import { HTTP_AP_GetClientUserNotificationSettings_Response } from '@api-new/notificationservice/HTTP_AP_GetClientUserNotificationSettings_Response';
import { HTTP_AP_GetCompanyNotificationSettings_Request } from '@api-new/notificationservice/HTTP_AP_GetCompanyNotificationSettings_Request';
import { HTTP_AP_GetCompanyNotificationSettings_Response } from '@api-new/notificationservice/HTTP_AP_GetCompanyNotificationSettings_Response';
import { HTTP_AP_GetEmailNotificationReportingDashboard_Request } from '@api-new/notificationservice/HTTP_AP_GetEmailNotificationReportingDashboard_Request';
import { HTTP_AP_GetEmailNotificationReportingDashboard_Response } from '@api-new/notificationservice/HTTP_AP_GetEmailNotificationReportingDashboard_Response';
import { HTTP_AP_GetEmailPreview_ForClientUserNotifications_Request } from '@api-new/notificationservice/HTTP_AP_GetEmailPreview_ForClientUserNotifications_Request';
import { HTTP_AP_GetEmailPreview_ForClientUserNotifications_Response } from '@api-new/notificationservice/HTTP_AP_GetEmailPreview_ForClientUserNotifications_Response';
import { HTTP_AP_GetEmailPreview_Request } from '@api-new/notificationservice/HTTP_AP_GetEmailPreview_Request';
import { HTTP_AP_GetEmailPreview_Response } from '@api-new/notificationservice/HTTP_AP_GetEmailPreview_Response';
import { HTTP_AP_GetNetworkNotificationSettings_Request } from '@api-new/notificationservice/HTTP_AP_GetNetworkNotificationSettings_Request';
import { HTTP_AP_IsSenderEmailDnsAuthenticated_Request } from '@api-new/notificationservice/HTTP_AP_IsSenderEmailDnsAuthenticated_Request';
import { HTTP_AP_IsSenderEmailDnsAuthenticated_Response } from '@api-new/notificationservice/HTTP_AP_IsSenderEmailDnsAuthenticated_Response';
import { HTTP_AP_ListNotificationSchedules_ForClientUserNotifications_Request } from '@api-new/notificationservice/HTTP_AP_ListNotificationSchedules_ForClientUserNotifications_Request';
import { HTTP_AP_ListNotificationSchedules_ForClientUserNotifications_Response } from '@api-new/notificationservice/HTTP_AP_ListNotificationSchedules_ForClientUserNotifications_Response';
import { HTTP_AP_ListNotifications_ForClientUserNotifications_Request } from '@api-new/notificationservice/HTTP_AP_ListNotifications_ForClientUserNotifications_Request';
import { HTTP_AP_ListNotifications_ForClientUserNotifications_Response } from '@api-new/notificationservice/HTTP_AP_ListNotifications_ForClientUserNotifications_Response';
import { HTTP_AP_NetworkNotificationSettings } from '@api-new/notificationservice/HTTP_AP_NetworkNotificationSettings';
import { HTTP_AP_ResendBetterDealAlertNotifications_Request } from '@api-new/notificationservice/HTTP_AP_ResendBetterDealAlertNotifications_Request';
import { HTTP_AP_ResendHomeReportNotifications_Request } from '@api-new/notificationservice/HTTP_AP_ResendHomeReportNotifications_Request';
import { HTTP_AP_UpdateAdvisorUserNotificationSettings_Request } from '@api-new/notificationservice/HTTP_AP_UpdateAdvisorUserNotificationSettings_Request';
import { HTTP_AP_UpdateAdvisorUserNotificationSettings_Response } from '@api-new/notificationservice/HTTP_AP_UpdateAdvisorUserNotificationSettings_Response';
import { HTTP_AP_UpdateClientUserNotificationSettings_Request } from '@api-new/notificationservice/HTTP_AP_UpdateClientUserNotificationSettings_Request';
import { HTTP_AP_UpdateClientUserNotificationSettings_Response } from '@api-new/notificationservice/HTTP_AP_UpdateClientUserNotificationSettings_Response';
import { HTTP_AP_UpdateCompanyNotificationSettings_Request } from '@api-new/notificationservice/HTTP_AP_UpdateCompanyNotificationSettings_Request';
import { HTTP_AP_UpdateCompanyNotificationSettings_Response } from '@api-new/notificationservice/HTTP_AP_UpdateCompanyNotificationSettings_Response';
import { HTTP_AP_UpdateNetworkNotificationSettings_Request } from '@api-new/notificationservice/HTTP_AP_UpdateNetworkNotificationSettings_Request';
import { HTTP_AP_ValidateBulkSetClientUsersNotificationSettings_Response } from '@api-new/notificationservice/HTTP_AP_ValidateBulkSetClientUsersNotificationSettings_Response';
import { HTTP_CP_ClientUserNotificationSettings } from '@api-new/notificationservice/HTTP_CP_ClientUserNotificationSettings';
import { HTTP_CP_SetPushNotificationToken_Request } from '@api-new/notificationservice/HTTP_CP_SetPushNotificationToken_Request';
import { HTTP_CP_UpdateClientUserNotificationSettings_Request } from '@api-new/notificationservice/HTTP_CP_UpdateClientUserNotificationSettings_Request';
import { Observable } from 'rxjs';
import { ApplicationHttpClient, IRequestOptions } from '../../../../../lib/services/application-http.service';

@Injectable({ providedIn: 'root' })
export class NotificationApiService {
  private readonly httpClient = inject(ApplicationHttpClient);

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- GRPC Endpoints ----------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // --- HTTP Endpoints - Adviser Portal (ap) ------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  HTTP_AP_BulkSetClientUsersNotificationSettings(
    request: HTTP_AP_BulkSetClientUsersNotificationSettings_Request,
    options?: IRequestOptions,
  ): Observable<undefined> {
    return this.httpClient.post(`/notification-service/ap/BulkSetClientUsersNotificationSettings`, request, options);
  }

  HTTP_AP_ExportEmailNotificationReporting(
    request: HTTP_AP_ExportEmailNotificationReporting_Request,
    options?: IRequestOptions,
  ): Observable<undefined> {
    return this.httpClient.post(`/notification-service/ap/ExportEmailNotificationReporting`, request, options);
  }

  HTTP_AP_ExportHomeReportDataToCSV(request?: undefined, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/notification-service/ap/ExportHomeReportDataToCSV`, request, options);
  }

  HTTP_AP_GenerateEmailNotificationReportingDashboardPDF(
    request: HTTP_AP_GenerateEmailNotificationReportingDashboardPDF_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GenerateEmailNotificationReportingDashboardPDF_Response> {
    return this.httpClient.get(`/notification-service/ap/GenerateEmailNotificationReportingDashboardPDF`, { params: request });
  }

  HTTP_AP_GetAdvisorUserNotificationSettings(
    request: HTTP_AP_GetAdvisorUserNotificationSettings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetAdvisorUserNotificationSettings_Response> {
    return this.httpClient.get(`/notification-service/ap/GetAdvisorUserNotificationSettings`, { params: request });
  }

  HTTP_AP_GetClientUserNotificationSettings(
    request: HTTP_AP_GetClientUserNotificationSettings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetClientUserNotificationSettings_Response> {
    return this.httpClient.get(`/notification-service/ap/GetClientUserNotificationSettings`, { params: request });
  }

  HTTP_AP_GetCompanyNotificationSettings(
    request: HTTP_AP_GetCompanyNotificationSettings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetCompanyNotificationSettings_Response> {
    return this.httpClient.get(`/notification-service/ap/GetCompanyNotificationSettings`, { params: request });
  }

  HTTP_AP_GetEmailNotificationReportingDashboard(
    request: HTTP_AP_GetEmailNotificationReportingDashboard_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetEmailNotificationReportingDashboard_Response> {
    return this.httpClient.get(`/notification-service/ap/GetEmailNotificationReportingDashboard`, { params: request });
  }

  HTTP_AP_GetEmailPreview(
    request: HTTP_AP_GetEmailPreview_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetEmailPreview_Response> {
    return this.httpClient.post(`/notification-service/ap/GetEmailPreview`, request, options);
  }

  HTTP_AP_GetEmailPreview_ForClientUserNotifications(
    request: HTTP_AP_GetEmailPreview_ForClientUserNotifications_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetEmailPreview_ForClientUserNotifications_Response> {
    return this.httpClient.post(`/notification-service/ap/GetEmailPreview_ForClientUserNotifications`, request, options);
  }

  HTTP_AP_GetNetworkNotificationSettings(
    request: HTTP_AP_GetNetworkNotificationSettings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_NetworkNotificationSettings> {
    return this.httpClient.get(`/notification-service/ap/GetNetworkNotificationSettings`, { params: request });
  }

  HTTP_AP_IsSenderEmailDnsAuthenticated(
    request: HTTP_AP_IsSenderEmailDnsAuthenticated_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_IsSenderEmailDnsAuthenticated_Response> {
    return this.httpClient.get(`/notification-service/ap/IsSenderEmailDnsAuthenticated`, { params: request });
  }

  HTTP_AP_ListNotifications_ForClientUserNotifications(
    request: HTTP_AP_ListNotifications_ForClientUserNotifications_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListNotifications_ForClientUserNotifications_Response> {
    return this.httpClient.get(`/notification-service/ap/ListNotifications_ForClientUserNotifications`, { params: request });
  }

  HTTP_AP_ListNotificationSchedules_ForClientUserNotifications(
    request: HTTP_AP_ListNotificationSchedules_ForClientUserNotifications_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListNotificationSchedules_ForClientUserNotifications_Response> {
    return this.httpClient.get(`/notification-service/ap/ListNotificationSchedules_ForClientUserNotifications`, { params: request });
  }

  HTTP_AP_ResendBetterDealAlertNotifications(
    request: HTTP_AP_ResendBetterDealAlertNotifications_Request,
    options?: IRequestOptions,
  ): Observable<undefined> {
    return this.httpClient.post(`/notification-service/ap/ResendBetterDealAlertNotifications`, request, options);
  }

  HTTP_AP_ResendHomeReportNotifications(
    request: HTTP_AP_ResendHomeReportNotifications_Request,
    options?: IRequestOptions,
  ): Observable<undefined> {
    return this.httpClient.post(`/notification-service/ap/ResendHomeReportNotifications`, request, options);
  }

  HTTP_AP_SendHomeReportNotifications(request?: undefined, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/notification-service/ap/SendHomeReportNotifications`, request, options);
  }

  HTTP_AP_UpdateAdvisorUserNotificationSettings(
    request: HTTP_AP_UpdateAdvisorUserNotificationSettings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_UpdateAdvisorUserNotificationSettings_Response> {
    return this.httpClient.put(`/notification-service/ap/UpdateAdvisorUserNotificationSettings`, request, options);
  }

  HTTP_AP_UpdateClientUserNotificationSettings(
    request: HTTP_AP_UpdateClientUserNotificationSettings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_UpdateClientUserNotificationSettings_Response> {
    return this.httpClient.put(`/notification-service/ap/UpdateClientUserNotificationSettings`, request, options);
  }

  HTTP_AP_UpdateCompanyNotificationSettings(
    request: HTTP_AP_UpdateCompanyNotificationSettings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_UpdateCompanyNotificationSettings_Response> {
    return this.httpClient.put(`/notification-service/ap/UpdateCompanyNotificationSettings`, request, options);
  }

  HTTP_AP_UpdateNetworkNotificationSettings(
    request: HTTP_AP_UpdateNetworkNotificationSettings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_NetworkNotificationSettings> {
    return this.httpClient.put(`/notification-service/ap/UpdateNetworkNotificationSettings`, request, options);
  }

  HTTP_AP_ValidateBulkSetClientUsersNotificationSettings(
    request: HTTP_AP_BulkSetClientUsersNotificationSettings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ValidateBulkSetClientUsersNotificationSettings_Response> {
    return this.httpClient.post(`/notification-service/ap/ValidateBulkSetClientUsersNotificationSettings`, request, options);
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- HTTP Endpoints - Client Portal (cp) -------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  HTTP_CP_GetClientUserNotificationSettings(
    request?: undefined,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_ClientUserNotificationSettings> {
    return this.httpClient.get(`/notification-service/cp/GetClientUserNotificationSettings`, { params: request });
  }

  HTTP_CP_SetPushNotificationToken(request: HTTP_CP_SetPushNotificationToken_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/notification-service/cp/SetPushNotificationToken`, request, options);
  }

  HTTP_CP_UpdateClientUserNotificationSettings(
    request: HTTP_CP_UpdateClientUserNotificationSettings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_ClientUserNotificationSettings> {
    return this.httpClient.put(`/notification-service/cp/UpdateClientUserNotificationSettings`, request, options);
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- HTTP Endpoints - Extended (x) -------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // Empty

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- INIT Endpoints ----------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // Empty

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- PUBLIC Endpoints --------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  PUBLIC_UptimeCheck(request?: undefined, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.get(`/notification-service/.public/UptimeCheck`, { params: request });
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- SPECIAL Endpoints -------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // TODO #6091 Delete this after the AdvisorUserNotificationSettings -> AdvisorUserSettingsForNotifications migration is complete
}
